import { useEffect, useState } from 'react'
import { FilterBox } from './table'

const TableFilter = ({ headerGroup, search, sort, clearFilters, refreshGrid, setting }) => {
  const [inputSearch, setInputSearch] = useState({})
  useEffect(() => {
    if (clearFilters) {
      setInputSearch({})
    }
  }, [clearFilters])
  return (
    <>
      {' '}
      {headerGroup.headers.map((column, key) => (
        <th style={column.commonStyle} className='rt-th '>
          {column.filter && setting.filiter_all_columns ? (
            <div className={'table-column-search'}>
              <FilterBox
                filterValue={column.savedFilterValue}
                filterLabel={column.savedFilterLabel}
                refreshGrid={refreshGrid}
                clearFilters={clearFilters}
                onChangeInput={(val) => {
                  setInputSearch((data) => {
                    let newData = data
                    newData[`-filter-${column.id}`] = val
                    return newData
                  })
                }}
                triggerSearch={(text, label) => {
                  let data = { ...inputSearch, ['-filter-' + column.id]: text }

                  if (label) {
                    data = { ...data, ['-filter-' + column.id]: text, ['-filter-' + column.id + '_label']: label }
                  }
                  search(data, sort)
                }}
                column={column}
              />
            </div>
          ) : null}
        </th>
      ))}
    </>
  )
}

export default TableFilter
